import { formatDate } from '../formatter/formatDate.util';

export const toastAdvertismentAgreementResult = (Popup: any, result: boolean) => {
  const resultText = result ? '처리' : '철회';

  Popup.toast(
    `광고성 정보 수신 ${resultText} 요청이\n정상적으로 처리되었습니다.\n(${formatDate(new Date().toString())})`,
  );
};
